export default function install(Vue, options) {
  var vm = new Vue({
    data: {
      languages: []//,
      // selectedLanguage: {}
    }
  });

  Object.defineProperties(Vue.prototype, {
    $languages: {
      get: function() {
        return vm.languages.filter(lang => lang.isActive);
      },
      set: function(value) {
        vm.languages = value;
        return this;
      }
     }//,
    // $selectedLanguage: {
    //   get: function() {
    //     return vm.selectedLanguage;
    //   },
    //   set: function(value) {
    //     vm.selectedLanguage = value;
    //     return this;
    //   }
  });

  axios.get("/api/language/getall").then(response => {
    vm.languages = response.data.data;
  });
}



//////////////////
// WEBPACK FOOTER
// ./Helpers/Plugins/languages.js
// module id = null
// module chunks = 